import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ResumenClubComponent from "../../../components/comisionesAnualidad/resumenClub/ResumenClub";
import { ResumenClubStore, resumenClubStore } from "./ResumenClub.store";
import {
  ResumenClubDispatcher,
  resumenClubDispatcher
} from "./ResumenClub.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ResumenClubStore, ResumenClubDispatcher {}
interface State {}

@Router()
@ReduxConnect(resumenClubStore, resumenClubDispatcher)
export default class ResumenClubContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Resumen por Club - Anualidades" />
          <ResumenClubComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
